import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M14.666 11.957a.875.875 0 0 1 0 1.75H1.333a.875.875 0 1 1 0-1.75zm0-5.833a.875.875 0 1 1 0 1.75H1.333a.875.875 0 0 1 0-1.75zm0-5.833a.875.875 0 1 1 0 1.75H1.333a.875.875 0 0 1 0-1.75z"
    }, null, -1)
  ]))]))
}
export default { render: render }